var _path, _circle, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTelegramSquare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 4a4 4 0 014-4h16a4 4 0 014 4v16a4 4 0 01-4 4H4a4 4 0 01-4-4V4z",
    fill: "#29A9EB"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 11,
    fill: "#29A9EB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.962 11.735c3.759-1.552 6.264-2.575 7.518-3.07C17.06 7.253 17.804 7.008 18.29 7c.106-.002.344.023.499.142.13.1.166.236.183.331.017.095.039.312.022.481-.194 1.933-1.034 6.623-1.46 8.787-.181.916-.537 1.224-.882 1.253-.748.066-1.317-.468-2.042-.92-1.134-.704-1.775-1.143-2.877-1.831-1.273-.796-.447-1.233.278-1.947.19-.187 3.488-3.031 3.552-3.29.008-.032.015-.152-.06-.215-.075-.064-.187-.042-.267-.025-.114.025-1.926 1.16-5.438 3.408-.514.335-.98.498-1.398.49-.46-.01-1.345-.248-2.004-.45-.807-.25-1.448-.38-1.393-.803.03-.22.35-.445.96-.676z",
    fill: "#fff"
  })));
}

export default SvgTelegramSquare;